import React, { useState } from "react";
import { motion } from "framer-motion";
import BookDemoForm from "../../../../components/BookDemoForm/BookDemoForm";

const NewHeroSection = () => {

      const [showFormModal, setShowFormModal] = useState(false);
    
      const handleFormToggle = () => {
        setShowFormModal(!showFormModal);
      };
  return (
    <section className="bg-white text-black font-sans py-16">
      {/* Hero Content */}
      <div className="text-center py-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-5xl mx-auto">
          <motion.h1
            className="text-5xl md:text-6xl font-extrabold text-gray-900 leading-tight mb-6"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Automate, Scale, Grow Efficiently
          </motion.h1>
          <motion.p
            className="text-lg md:text-xl text-gray-700 leading-relaxed mb-8 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            We combine artificial intelligence with automation to create incredibly efficient processes
            that connect your apps and automate actions between them, replacing manual work for massive
            gains in your team’s bandwidth, quality, speed, and customer experience. Fully custom and done-for-you.
          </motion.p>

          {/* Call to Action */}
          <motion.button
            className="px-8 py-4 text-lg font-semibold bg-blue-600 text-white rounded-full shadow-xl 
            hover:bg-blue-700 transition-transform transform hover:scale-105"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleFormToggle}>
            Free Consultation
          </motion.button>

          <p className="text-sm text-gray-500 mt-4 max-w-md mx-auto">
            You focus on growing your business, and we’ll handle the AI and automation that powers it.
            Together, we’ll unlock new levels of efficiency and growth.
          </p>
        </div>
      </div>

      {/* Stats Section */}
      <div className="bg-black py-24">
        <div className="flex flex-col md:flex-row items-center justify-center text-white gap-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center px-6"
          >
            <p className="text-6xl font-bold">40,000+</p>
            <p className="text-lg underline">Hours of manual work</p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="max-w-2xl text-center px-6"
          >
            <p className="text-2xl md:text-3xl font-semibold">
              Have been replaced with AI and Automation for our clients
            </p>
          </motion.div>
        </div>
      </div>
      {showFormModal && <BookDemoForm onClose={handleFormToggle} />}
    </section>
  );
};

export default NewHeroSection;
